import {get} from 'lodash'

export default {
    computed: {
        /**
         * Access the global App object.
         */
        App() {
            return window.App;
        },
        /**
         * Access the global translations object.
         */
        Translations() {
            return window.App?.translations;
        },
        /**
         * Access the global static variables.
         */
        Static() {
            return window.App?.static;
        }
    },
    methods: {
        $t(key, def) {
            return get(this.Translations, key, def ?? key)
        }
    }
};
